import React, { Fragment } from "react";
import Layout from "../../src/layout";
import { NextSeo } from "next-seo";
import Breadcrumb from "../../src/ui/breadcrumb";
import BlocText from "../../src/ui/blocs/text";
import BlocTeam from "../../src/ui/blocs/team";
import TeamMemberFullSize from "../../src/ui/blocs/team/teamMemberFullSize";
import TeamMember from "../../src/ui/blocs/team/teamMember";
import TeamMemberDescription from "../../src/ui/blocs/team/teamMemberDescription";
import { useState } from "react";
import data from "./data.json";
import { getSEONoFollow, getSEONoIndex } from "../../src/utils/nextjs/seo";
import styles from "./apropos.module.scss";
import { GetServerSidePropsContext } from "next";
import { Viewport } from "@/types/enum";
import { SERVER_SIDE_CACHE_HEADER } from "@/configs/cache";

type AProposProps = {
    json: typeof data;
    viewport: Viewport;
};

const APropos = ({ json, viewport }: AProposProps) => {
    const title = "À propos";
    const [idDescription, setIdDescription] = useState<number>(-1);

    const handleOnClick = (id: number) => {
        if (id === idDescription) {
            setIdDescription(-1);
        } else {
            setIdDescription(id);
        }
    };

    const { blocHaut, blocEquipe, blocComplice, blocBas } = json;

    return (
        <Layout mainBody={false} viewport={viewport}>
            <NextSeo nofollow={getSEONoFollow()} noindex={getSEONoIndex()} title={title} />

            <div className={styles.me}>
                <div className={styles.body}>
                    <Breadcrumb title={title} />
                    <div id="main-content">
                        <h1>{title}</h1>
                    </div>
                </div>

                {blocHaut &&
                    blocHaut.map((bloc, index) => {
                        return <BlocText key={bloc.id || index} contenu={bloc} />;
                    })}

                <BlocTeam title="Notre équipe éditoriale" isFullSize>
                    {blocEquipe &&
                        blocEquipe.map((person, index) => (
                            <TeamMemberFullSize key={person.id || index} contenu={person} />
                        ))}
                </BlocTeam>

                <BlocTeam title="Nos complices" isDark>
                    {blocComplice &&
                        blocComplice.map((person, index) => (
                            <Fragment key={person.id || index}>
                                <TeamMember
                                    contenu={person}
                                    idDescription={idDescription}
                                    onClick={handleOnClick}
                                />
                                <TeamMemberDescription
                                    contenu={person}
                                    idDescription={idDescription}
                                />
                            </Fragment>
                        ))}
                </BlocTeam>

                {blocBas &&
                    blocBas.map((bloc, index) => (
                        <BlocText
                            key={bloc.id || index}
                            contenu={bloc}
                            isImage={false}
                            isCentered
                            viewport={viewport}
                        />
                    ))
                }
            </div>
        </Layout>
    );
};

export default APropos;

export const getServerSideProps = async ({ res, query }: GetServerSidePropsContext) => {
    const imageBaseUrl = process?.env?.IMAGESNASSETTINGS_ROOTURL;
    const viewport = query["viewport"] || "desktop";

    res.setHeader("Cache-Control", SERVER_SIDE_CACHE_HEADER);

    if (imageBaseUrl) {
        data.blocHaut.forEach((bloc) => {
            bloc.imageUrl = bloc.imageUrl.replace("{0}", imageBaseUrl);
        });
        data.blocEquipe.forEach((bloc) => {
            bloc.imageUrl = bloc.imageUrl.replace("{0}", imageBaseUrl);
        });
        data.blocComplice.forEach((bloc) => {
            bloc.imageUrl = bloc.imageUrl.replace("{0}", imageBaseUrl);
        });
    }

    return {
        props: {
            json: data,
            viewport: viewport as string,
        },
    };
};
